import Link from "next/link"
import React from "react"

/**
 * Single-region storefront (Story 1.1 / AC2): there is no `[countryCode]`
 * prefix, so links point straight at the path. Kept as a thin wrapper so the
 * many existing call sites don't have to change and a future prefix (if ever
 * needed) has a single place to live.
 */
const LocalizedClientLink = ({
  children,
  href,
  ...props
}: {
  children?: React.ReactNode
  href: string
  className?: string
  onClick?: () => void
  passHref?: true
  [x: string]: unknown
}) => {
  return (
    <Link href={href} {...props}>
      {children}
    </Link>
  )
}

export default LocalizedClientLink
